import script from "./ActivityList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityList.vue?vue&type=script&setup=true&lang=ts"

import "./ActivityList.vue?vue&type=style&index=0&id=ded28d6a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ded28d6a"]])

export default __exports__